module.exports = __webpack_public_path__ + "ie.svg?4d307d87130980cbd6d73b2e47f5c24e";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/ie.svg
// module id = 835
// module chunks = 27